require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./linn-county-community-intervention-program.json") })
        }
      }, "path---linn-county-community-intervention-program");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---linn-county-community-intervention-program!./.cache/json/linn-county-community-intervention-program.json
// module id = 927
// module chunks = 231608221292675